import React from "react";
import PropTypes from "prop-types";
import StackedBarChart from "../../StackedBarChart/StackedBarChart";
import PieChart from "../../PieChart/PieChart";

function ResultDistributionChart({ stats }) {
  const { winner, forced, error } = stats;
  return (
    <PieChart
      title="Distribuzione Colpi per risultato"
      labels={["Vincente", "Forzato", "Gratuito"]}
      datasets={[
        {
          data: [
            winner.forehand + winner.backhand + winner.volley + winner.smash,
            forced.forehand + forced.backhand + forced.volley + forced.smash,
            error.forehand + error.backhand + error.volley + error.smash,
          ],
          backgroundColor: ["#5cb85c", "#f0ad4e", "#d9534f"],
        },
      ]}
    />
  );
}

ResultDistributionChart.propTypes = {};

export default ResultDistributionChart;
